import { supabase } from './supabase';

/**
 * Wrapper around fetch that automatically injects the Supabase session token
 * as an Authorization: Bearer header. Use this for all API routes protected
 * by withAuth middleware (lib/apiAuth.ts).
 */
export async function authedFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const { data: { session } } = await supabase.auth.getSession();

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string> || {}),
  };

  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`;
  }

  return fetch(url, { ...options, headers });
}
